import { useParams } from "next/navigation"
import { useMemo } from "react"

export type PartialAttributes = {
    page?: {
      data: null | {
        attributes: {
          page_category?: {
            data: null | {
              attributes: {
                path: string
              }
            }
          }
          slug: string,
        },
      }
    },
    url?: string,
    newTab?: boolean,
  }

  
export const useHrefFromPageOrURL = (attributes: PartialAttributes) => {
    const params = useParams<{ lang: string }>()
    const href = useMemo(() => {
      const pageData = attributes?.page?.data;

      if (pageData) {
        const pageCategoryData = pageData.attributes.page_category?.data;
        if (pageCategoryData) {
          return `/${params.lang}/${pageCategoryData.attributes.path}/${pageData.attributes.slug}`
        }

        return `/${params.lang}/${pageData.attributes.slug}`
      }

      return attributes?.url ?? "";
    }, [attributes, params.lang])

    return href
  }
